module.exports = __webpack_public_path__ + "img/送货车_transporter.8089e0c7.svg";